'use client';

import { memo } from 'react';
import {
  Control,
  UseFormRegister,
  UseFormSetValue,
  useFormState,
  UseFormTrigger,
} from 'react-hook-form';
import NextButton from '@/components/Button/NextButton';
import { EducationalLevel, FormData } from '@/types/form';
import { fieldRules } from '@/utils/form';
import generalStyles from '../FormBody.module.scss';
import Select from './Select/Select';
import useModal from '@/hooks/useModal';
import styles from './StepNine.module.scss';

interface Props {
  formData?: FormData;
  handleSubmit?: (e?: React.BaseSyntheticEvent) => Promise<void>;
  register?: UseFormRegister<FormData>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control?: Control<FormData, any, FormData>;
  setValue?: UseFormSetValue<FormData>;
  trigger?: UseFormTrigger<FormData>;
}

const educationValues = Object.values(EducationalLevel);

const EducationForm = ({
  formData,
  handleSubmit,
  register,
  control,
  setValue,
  trigger,
}: Props) => {
  const { closeModal } = useModal();
  const { errors } = useFormState({ control });
  const submitForm = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const isValid = await trigger?.();
    if (isValid) {
      await handleSubmit?.();
      closeModal();
    }
  };

  return (
    <form onSubmit={submitForm} className={styles.form}>
      {register && (
        <Select
          id="educational_level"
          placeholder="Choose your level of education"
          label="Highest level of education"
          values={educationValues}
          register={register('educational_level', fieldRules.educational_level)}
          currentValue={formData?.educational_level || null}
          error={errors?.educational_level}
          setValue={setValue}
          mark="educational_level"
          trigger={trigger}
        />
      )}
      <NextButton
        buttonType="submit"
        type="button"
        text="Apply changes"
        styles={`${generalStyles.button} ${generalStyles.smallButton}`}
      />
    </form>
  );
};

export default memo(EducationForm);
